/* src/app/component/navbar/navbar.component.scss */
.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 210px;
  border-right: 1px solid #fff;
  position: fixed;
  top: 0;
  left: 0;
  color: #101828;
}
.sidebar {
  width: 250px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #dadada;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.img {
  padding-top: 32px;
  padding-left: 20px;
  padding-bottom: 32px;
}
.img img {
  width: 16px;
  margin-left: 12px;
}
.menu {
  padding-left: 16px;
}
.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.menu ul .menu-item {
  padding: 10px 12px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
.menu ul .menu-item i {
  margin-right: 10px;
  transition: color 0.3s ease;
}
.menu ul .menu-item a,
.menu ul .menu-item span {
  color: #344054;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
}
.menu ul .menu-item:hover {
  color: #101828;
  font-weight: bold;
}
.menu ul .menu-item:hover i {
  color: #FF8C00;
}
.menu ul .menu-item a.active,
.menu ul .menu-item span.active {
  color: #101828;
  font-weight: bold;
}
.menu ul .menu-item a:hover,
.menu ul .menu-item span:hover {
  color: #101828;
  font-weight: bold;
}
::ng-deep .profile-dropdown {
  padding: 0 !important;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  background-color: #fff;
  width: 220px;
}
::ng-deep .profile-dropdown .dropdown-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}
::ng-deep .profile-dropdown .dropdown-item {
  padding: 10px 12px;
  cursor: pointer;
  color: #344054;
  font-weight: 500;
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  font-size: 14px;
}
::ng-deep .profile-dropdown .dropdown-item:hover {
  color: #101828;
  font-weight: bold;
}
::ng-deep .profile-dropdown .dropdown-item:hover i {
  color: #FF8C00;
}
::ng-deep .profile-dropdown .dropdown-item i {
  margin-right: 8px;
  font-size: 16px;
  color: #6b7280;
}
::ng-deep .p-overlaypanel .p-overlaypanel-content {
  padding: 0px;
  box-shadow: none;
}
.bottom-box {
  border-top: 1px solid #EDEDED;
}
.bottom-menu ul {
  list-style: none;
  padding: 0px 0px;
  margin: 0;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #EDEDED;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  box-shadow: 0px 6px 8px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
}
.bottom-menu .menu-item:hover {
  color: #101828;
  font-weight: bold;
}
.bottom-menu .menu-item:hover i {
  color: #FF8C00;
}
.bottom-menu .menu-item {
  padding: 10px 12px 4px 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.bottom-menu .menu-item1 {
  padding: 0px 12px 10px 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.bottom-menu .menu-item1:hover i {
  color: #FF8C00;
}
.bottom-menu .menu-item1:hover {
  color: #101828;
  font-weight: bold;
}
.user-info {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 12px;
}
.icon-circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.initials {
  font-size: 20px;
  font-weight: bold;
  color: white;
}
.username .name {
  margin: 0;
  font-size: 14px;
  color: black;
  font-weight: bold;
  line-height: 20px;
}
.username {
  margin: 0;
  font-size: 14px;
  color: #708090;
}
.email {
  margin: 0;
  font-size: 14px;
  color: #708090;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
::ng-deep .p-confirm-dialog {
  width: 600px !important;
  border-radius: 12px;
}
::ng-deep .p-confirm-dialog-icon {
  font-size: 25px;
}
::ng-deep .p-confirm-dialog-accept {
  background:
    linear-gradient(
      135deg,
      #FFD700,
      #FFA500);
  border: none;
  color: #0F172A;
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
}
::ng-deep .p-confirm-dialog-reject {
  background-color: white !important;
  color: #000;
  border: 1px solid #D0D5DD;
  height: 40px;
  border-radius: 8px;
}
::ng-deep .p-confirm-dialog-reject:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
::ng-deep .p-confirm-dialog-accept:hover {
  background:
    linear-gradient(
      135deg,
      #FFA500,
      #FFD700);
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(255, 215, 0, 0.4);
}
/*# sourceMappingURL=navbar.component-QCFHCBBT.css.map */
